import { Box, LinearProgress, Typography } from "@mui/material";
import { Card } from "src/design/Card";
import { useTranslation } from "react-i18next";
import { DayOfWeekEntry } from "src/data/admin/types/analytics";
import {
  colorError,
  colorSuccess,
  colorTextMuted,
  colorTextSecondary,
  colorWarning,
} from "src/design/tokens";
import { AnalyticsCardHeader } from "./AnalyticsCardHeader";

const getBarColor = (pct: number) => {
  if (pct >= 80) return colorSuccess;
  if (pct >= 60) return colorWarning;
  return colorError;
};

interface Props {
  data: DayOfWeekEntry[];
}

export const DayOfWeekPerformance = ({ data }: Props) => {
  const { t } = useTranslation();

  return (
    <Card sx={{ flexDirection: "column", gap: 2, height: '100%' }}>
      <Box sx={{ height: '15%' }}>
        <AnalyticsCardHeader
          title={t("analytics.dayOfWeek.title")}
          subtitle={t("analytics.dayOfWeek.subtitle")}
          subtitleSpacing={6}
        />
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, width: "100%", height: "78%", justifyContent: 'space-evenly' }}>
        {data.map((entry) => (
          <Box key={entry.day} sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Typography
              sx={{
                fontSize: "0.8rem",
                color: colorTextSecondary,
                width: 56,
                flexShrink: 0,
                whiteSpace: "nowrap",
              }}
            >
              {entry.day}
            </Typography>
            <Box sx={{ flex: 1 }}>
              <LinearProgress
                variant="determinate"
                value={entry.percentage}
                sx={{
                  height: 10,
                  borderRadius: 5,
                  backgroundColor: "#F3F4F6",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: getBarColor(entry.percentage),
                    borderRadius: 5,
                  },
                }}
              />
            </Box>
            <Typography
              sx={{
                fontSize: "0.75rem",
                color: colorTextMuted,
                width: 140,
                flexShrink: 0,
                textAlign: "right",
              }}
            >
              {t("analytics.dayOfWeek.bookingsLabel", {
                count: entry.bookings,
                pct: entry.percentage,
              })}
            </Typography>
          </Box>
        ))}
      </Box>
    </Card>
  );
};
